import {loadScript, lazyLoad} from 'methods/utils';
import Swiper from 'vendor_components/swiper.min';
import KurortMapModal from 'components/kurort-map-modal';

/**
 * Блок интересные места рядом
 */
new Swiper('#OtherPlaces .swiper', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: '#OtherPlaces .js-widget-next',
        prevEl: '#OtherPlaces .js-widget-prev',
    }
});

/**
 * VK плагин
 */
loadScript('//vk.com/js/api/openapi.js?120').then(() => {

    const $widget = document.getElementById('vk_widget');

    if ($widget) {
        const vkGroupId = $widget.getAttribute('data-vk-group-id');

        if (vkGroupId) {
            /**
             * Подключаем VK плагин
             */
            function VK_Widget_Init() {
                document.getElementById('vk_widget').innerHTML = '<div id="vk_groups"></div>';

                VK.Widgets.Group('vk_groups', {
                    mode: 3,
                    color2: '37474F',
                    width: 'auto',
                    no_cover: 1,
                }, vkGroupId);
            }

            VK_Widget_Init();

            document.addEventListener('resize', VK_Widget_Init)
        }
    }
});

/**
 * Обработчик кнопки "Показать ещё"
 */
const morePublicationsLoad = (button, container) => {
    button.addEventListener('click', async () => {
        const url = button.getAttribute('href');

        button.classList.add('loading');
        button.disabled = true;

        const response = await fetch(url, {
            headers: {'X-Requested-With': 'XMLHttpRequest'},
        });

        if (response.ok) {
            const json = await response.json();

            if (json.more_href) {
                button.setAttribute('href', json.more_href);
            } else {
                button.remove();
            }

            if (json.places_list) {
                container.insertAdjacentHTML('beforeend', json.places_list);
            }

            // lazyLoad фото
            lazyLoad();
        }

        button.classList.remove('loading');
        button.disabled = false;
    });
};

const $morePublicationsButton = document.querySelector('.js-morePublications');
const $publicationsList = document.querySelector('.js-publicationsList');

if ($morePublicationsButton) {
    morePublicationsLoad($morePublicationsButton, $publicationsList);
}

// Карта
const mapModal = new KurortMapModal(document.querySelector('.js-mapModal'), {});
const $mapModalOpen = document.querySelector('.js-mapModalOpen');

$mapModalOpen.addEventListener('click', () => mapModal.open().then(() => {
    const placemarks = JSON.parse($mapModalOpen.querySelector('script').innerHTML);

    if (placemarks) {
        mapModal.setPlacemarks(placemarks);
    }

    mapModal.preloaders(false);
}));
